// extracted by mini-css-extract-plugin
export var cell = "_65-4";
export var headerCell = "_65-2";
export var rowHeader = "_65-3";
export var table = "_65-1";
export var tableContainer = "_65-0";